import React from 'react';
import {connect} from 'react-redux';
import {changeProperties, changePropertiesById2} from '../../redux/actions';
import EditableSelect from './EditableSelect';
import objeler from '../objeler';
import StructuredBindingPanel from './StructuredBindingPanel';

class TableProperties extends React.Component {
    
    state = {
        validationError: null
    }
    
    handleModeChange = (e) => {
        const mode = e.target.value;
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        if (mode === 'Dynamic') {
            // Show warning if no DataSource selected
            const element = this.getElement();
            if (!element.DataSource || element.DataSource.trim() === '') {
                this.setState({
                    validationError: '⚠️ Dinamik tablo için DataSource seçimi zorunludur!'
                });
            }
            
            // Update using changePropertiesById2 to preserve properties.DataSource
            this.props.changePropertiesById2(elementId, {
                Bound: true,
                IsDynamic: true,
                properties: {
                    ...(currentElement?.properties || {}),
                    Mode: mode,
                    Bound: true,
                    IsDynamic: true,
                    Continuous: true
                }
            });
        } else {
            // Clear BOTH root and properties.DataSource when switching to Manual mode
            this.props.changePropertiesById2(elementId, {
                DataSource: '',
                Bound: false,
                IsDynamic: false,
                properties: {
                    ...(currentElement?.properties || {}),
                    Mode: mode,
                    Bound: false,
                    IsDynamic: false,
                    DataSource: ''
                }
            });
            
            this.setState({ validationError: null });
        }
    }
    
    handleBorderColorChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                BorderColor: e.target.value
            }
        });
    }
    
    handleBorderWidthChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                BorderWidth: e.target.value
            }
        });
    }
    
    handleBorderStyleChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                BorderStyle: e.target.value
            }
        });
    }
    
    handleZebraStripeChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                ZebraStripe: e.target.checked
            }
        });
    }
    
    handleAlternateColorChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                AlternateColor: e.target.value
            }
        });
    }
    
    handleHeaderHeightChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                HeaderHeight: parseInt(e.target.value) || 30
            }
        });
    }
    
    handleRowHeightChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                RowHeight: parseInt(e.target.value) || 25
            }
        });
    }
    
    handleKeepTogetherChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                KeepTogether: e.target.checked
            }
        });
    }
    
    handleMinRowsChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                MinRowsOnPage: parseInt(e.target.value) || 3
            }
        });
    }
    
    handleAddRow = () => {
        const element = this.getElement();
        const tableData = element.TableData || [];
        const columnCount = tableData[0] ? tableData[0].Cells.length : 3;
        const newRowIndex = tableData.length;
        
        const newRow = {
            Height: element.RowHeight || 25,
            isHeader: false,
            Embed: {},
            Cells: Array(columnCount).fill(null).map((_, colIndex) => ({
                v: `Row ${newRowIndex + 1}, Col ${colIndex + 1}`,
                c: '#000000',
                span: 1,
                w: 100,
                h: element.RowHeight || 25,
                bg: 'transparent',
                align: 'left',
                bold: false,
                fontSize: 12
            }))
        };
        
        const newTableData = [...tableData, newRow];
        console.log('✅ Add Row:', `${tableData.length} rows → ${newTableData.length} rows`);
        
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                TableData: newTableData
            }
        });
    }
    
    handleRemoveRow = () => {
        const element = this.getElement();
        const tableData = element.TableData || [];
        if (tableData.length > 1) {
            const newTableData = tableData.slice(0, -1);
            console.log('❌ Remove Row:', `${tableData.length} rows → ${newTableData.length} rows`);
            
            const {activeElement, objects} = this.props;
            const elementId = activeElement.id || activeElement;
            const currentElement = objects[elementId];
            
            this.props.changePropertiesById2(elementId, {
                properties: {
                    ...(currentElement?.properties || {}),
                    TableData: newTableData
                }
            });
        } else {
            console.log('⚠️ Cannot remove row: minimum 1 row required');
        }
    }
    
    handleAddColumn = () => {
        const element = this.getElement();
        const tableData = element.TableData || [];
        if (tableData.length === 0) return;
        
        const oldColCount = tableData[0] ? tableData[0].Cells.length : 0;
        const newData = tableData.map((row, rowIndex) => {
            const newColIndex = row.Cells.length;
            return {
                ...row,
                Cells: [...row.Cells, {
                    v: `Row ${rowIndex + 1}, Col ${newColIndex + 1}`,
                    c: '#000000',
                    span: 1,
                    w: 100,
                    h: row.Height || 25,
                    bg: 'transparent',
                    align: 'left',
                    bold: row.isHeader || false,
                    fontSize: 12
                }]
            };
        });
        
        console.log('✅ Add Column:', `${oldColCount} cols → ${oldColCount + 1} cols`);
        
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                TableData: newData
            }
        });
    }
    
    handleRemoveColumn = () => {
        const element = this.getElement();
        const tableData = element.TableData || [];
        const oldColCount = tableData[0] ? tableData[0].Cells.length : 0;
        
        if (tableData.length === 0 || oldColCount <= 1) {
            console.log('⚠️ Cannot remove column: minimum 1 column required');
            return;
        }
        
        const newData = tableData.map(row => ({
            ...row,
            Cells: row.Cells.slice(0, -1)
        }));
        
        console.log('❌ Remove Column:', `${oldColCount} cols → ${oldColCount - 1} cols`);
        
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                TableData: newData
            }
        });
    }
    
    handleCellEdit = (rowIndex, cellIndex, value) => {
        const element = this.getElement();
        const tableData = element.TableData || [];
        
        // Deep copy to avoid mutating state
        const newData = tableData.map((row, rIdx) => ({
            ...row,
            Cells: row.Cells.map((cell, cIdx) => {
                if (rIdx === rowIndex && cIdx === cellIndex) {
                    return {...cell, v: value};
                }
                return {...cell};
            })
        }));
        
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                TableData: newData
            }
        });
    }
    
    initializeTableData = () => {
        console.log('🔄 Initializing Table Data (3x3)');
        const defaultData = [
            {
                Height: 30,
                isHeader: true,
                Embed: {},
                Cells: [
                    {v: 'Header 1', c: '#000000', span: 1, w: 100, h: 30, bg: 'transparent', align: 'left', bold: true, fontSize: 12},
                    {v: 'Header 2', c: '#000000', span: 1, w: 100, h: 30, bg: 'transparent', align: 'left', bold: true, fontSize: 12},
                    {v: 'Header 3', c: '#000000', span: 1, w: 100, h: 30, bg: 'transparent', align: 'left', bold: true, fontSize: 12}
                ]
            },
            {
                Height: 25,
                isHeader: false,
                Embed: {},
                Cells: [
                    {v: 'Row 1, Col 1', c: '#000000', span: 1, w: 100, h: 25, bg: 'transparent', align: 'left', bold: false, fontSize: 12},
                    {v: 'Row 1, Col 2', c: '#000000', span: 1, w: 100, h: 25, bg: 'transparent', align: 'left', bold: false, fontSize: 12},
                    {v: 'Row 1, Col 3', c: '#000000', span: 1, w: 100, h: 25, bg: 'transparent', align: 'left', bold: false, fontSize: 12}
                ]
            },
            {
                Height: 25,
                isHeader: false,
                Embed: {},
                Cells: [
                    {v: 'Row 2, Col 1', c: '#000000', span: 1, w: 100, h: 25, bg: 'transparent', align: 'left', bold: false, fontSize: 12},
                    {v: 'Row 2, Col 2', c: '#000000', span: 1, w: 100, h: 25, bg: 'transparent', align: 'left', bold: false, fontSize: 12},
                    {v: 'Row 2, Col 3', c: '#000000', span: 1, w: 100, h: 25, bg: 'transparent', align: 'left', bold: false, fontSize: 12}
                ]
            }
        ];
        
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        const currentProps = currentElement?.properties || {};
        this.props.changePropertiesById2(elementId, {
            // Root seviye alanlarını koru
            Bound: currentElement?.Bound || currentProps.Bound || false,
            DataSource: currentElement?.DataSource || currentProps.DataSource || '',
            IsDynamic: currentElement?.IsDynamic || currentProps.IsDynamic || false,
            ColumnMapping: currentElement?.ColumnMapping || currentProps.ColumnMapping || [],
            properties: {
                ...currentProps,
                TableData: defaultData
            }
        });
    }
    
    handleDataSourceChange = (value) => {
        console.log('✓ DataSource changed to:', value);
        
        // Clear validation error when DataSource is selected
        if (value && value.trim() !== '') {
            this.setState({ validationError: null });
        }
        
        // Update BOTH root level AND properties.DataSource for backend compatibility
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            DataSource: value,
            Bound: value ? true : false,
            properties: {
                ...(currentElement?.properties || {}),
                DataSource: value,
                Bound: value ? true : false
            }
        });
        
        console.log('💾 Updated DataSource:', {
            root: value,
            properties: value
        });
    }
    
    handleContinuousChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                Continuous: e.target.checked
            }
        });
    }
    
    handleFlowLayoutChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                FlowLayout: e.target.checked
            }
        });
    }
    
    handleFlowAfterChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                FlowAfter: e.target.value
            }
        });
    }
    
    handleFlowMarginChange = (e) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        
        this.props.changePropertiesById2(elementId, {
            properties: {
                ...(currentElement?.properties || {}),
                FlowMargin: parseInt(e.target.value) || 20
            }
        });
    }
    
    handleFieldMappingChange = (columnIndex, fieldName) => {
        console.log('🔧 handleFieldMappingChange called:', {columnIndex, fieldName});
        
        const element = this.getElement();
        console.log('🔧 Current element:', element);
        
        // Validate DataSource is selected for Dynamic tables
        if (element.IsDynamic && (!element.DataSource || element.DataSource.trim() === '')) {
            this.setState({
                validationError: '❌ Lütfen önce DataSource seçin!'
            });
            alert('Column mapping yapmadan önce DataSource seçmelisiniz!');
            return;
        }
        
        // Get fresh ColumnMapping from Redux state
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId];
        const columnMapping = currentElement?.ColumnMapping || currentElement?.properties?.ColumnMapping || [];
        
        console.log('🔧 Fresh ColumnMapping from Redux:', columnMapping);
        
        // Ensure ColumnMapping is array of objects with correct structure
        const newMapping = [...columnMapping];
        while (newMapping.length <= columnIndex) {
            newMapping.push({ColumnIndex: newMapping.length, FieldName: '', Format: ''});
        }
        
        newMapping[columnIndex] = {
            ColumnIndex: columnIndex,
            FieldName: fieldName,
            Format: newMapping[columnIndex]?.Format || ''
        };
        
        console.log(`✓ Column ${columnIndex} mapped to: ${fieldName}`);
        console.log('✓ New ColumnMapping:', newMapping);
        console.log('✓ Updating element:', elementId);
        
        // Update both root level and properties for compatibility
        this.props.changePropertiesById2(elementId, {
            ColumnMapping: newMapping,
            properties: {
                ...(objects[elementId]?.properties || {}),
                ColumnMapping: newMapping
            }
        });
        
        // Debug: Check if Redux state was actually updated
        setTimeout(() => {
            const updatedElement = this.props.objects[elementId];
            console.log('🔍 Redux state after update:', {
                elementId,
                rootColumnMapping: updatedElement?.ColumnMapping,
                propsColumnMapping: updatedElement?.properties?.ColumnMapping
            });
        }, 100);
    }
    
    getDataSourceItems = () => {
        if (objeler.ModalDocParameters && objeler.ModalDocParameters.DataSource) {
            const items = objeler.ModalDocParameters.DataSource.map(ds => {
                const name = ds.title || ds.Title || 'Unnamed';
                let fields = [];
                
                // PRIORITY 1: Parse from query FIRST (most reliable for SELECT columns)
                if (ds.query && ds.query.includes('select')) {
                    const selectMatch = ds.query.match(/select\s+(.+?)\s+from/i);
                    if (selectMatch && selectMatch[1]) {
                        const fieldNames = selectMatch[1].split(',').map(k => k.trim());
                        fields = fieldNames.map(fname => ({Name: fname, DataType: 'String'}));
                        console.log(`✅ [TableProperties] Parsed from query for "${name}":`, fields.map(f => f.Name).join(', '));
                    }
                }
                
                // PRIORITY 2: Use rows array ONLY if query parsing didn't work
                // NOTE: rows might contain bind fields only, so query parsing is more reliable
                if (fields.length === 0 && ds.rows && Array.isArray(ds.rows) && ds.rows.length > 0) {
                    // Check if rows looks like bind fields (usually just 1-2 fields)
                    // If it has more than 2 fields, it's probably the real field list
                    if (ds.rows.length > 2) {
                        fields = ds.rows.map(row => ({
                            Name: row.Name || row.name || row.value || '',
                            DataType: row.DataType || row.dataType || 'String'
                        }));
                        console.log(`✅ [TableProperties] Using rows for "${name}":`, fields.map(f => f.Name).join(', '));
                    } else {
                        console.warn(`⚠️ [TableProperties] Skipping rows for "${name}" (looks like bind fields, only ${ds.rows.length} items)`);
                    }
                }
                
                // PRIORITY 3: Try children array (nested structure)
                if (fields.length === 0 && ds.children && Array.isArray(ds.children)) {
                    const fieldsNode = ds.children.find(child => 
                        child.title === "Fields" || 
                        child.Title === "Fields" ||
                        (child.query && !child.title)
                    );
                    
                    if (fieldsNode && fieldsNode.rows && Array.isArray(fieldsNode.rows)) {
                        fields = fieldsNode.rows.map(row => ({
                            Name: row.Name || row.name || row.value || '',
                            DataType: row.DataType || row.dataType || 'String'
                        }));
                        console.log(`✅ [TableProperties] Using children.Fields for "${name}":`, fields.map(f => f.Name).join(', '));
                    }
                    else if (fieldsNode && fieldsNode.query) {
                        const selectMatch = fieldsNode.query.match(/select\s+(.+?)\s+from/i);
                        if (selectMatch && selectMatch[1]) {
                            const fieldNames = selectMatch[1].split(',').map(k => k.trim());
                            fields = fieldNames.map(fname => ({Name: fname, DataType: 'String'}));
                            console.log(`⚠️ [TableProperties] Parsed from children query for "${name}":`, fields.map(f => f.Name).join(', '));
                        }
                    }
                }
                
                // CRITICAL NOTE: Do NOT use ds.keys!
                // ds.keys contains bind field INDICES (e.g., "0" means "bind to parent's 0th field")
                // This is NOT the field list - it's the parent-child relationship configuration
                
                if (fields.length === 0) {
                    console.warn(`⚠️ [TableProperties] No fields found for "${name}". Check DataSource structure.`);
                    console.warn(`  - query: ${ds.query}`);
                    console.warn(`  - rows: ${ds.rows ? ds.rows.length : 0} items`);
                    console.warn(`  - keys: ${ds.keys}`);
                }
                
                console.log(`📊 [TableProperties] DataSource "${name}" final fields:`, fields.map(f => f.Name).join(', '));
                return {
                    value: name,
                    label: name,
                    Name: name,
                    Fields: fields
                };
            });
            console.log(`✓ [TableProperties] Total DataSources available: ${items.length}`);
            return items;
        }
        console.log('⚠️ [TableProperties] No DataSource found in objeler.ModalDocParameters');
        return [];
    }
    
    getSelectedDataSource = () => {
        const element = this.getElement();
        const dataSources = this.getDataSourceItems();
        return dataSources.find(ds => ds.Name === element.DataSource);
    }
    
    getFieldMapping = (columnIndex) => {
        const element = this.getElement();
        const columnMapping = element.ColumnMapping || [];
        const mapping = columnMapping[columnIndex];
        
        // Handle both string and object formats
        let result = '';
        if (typeof mapping === 'string') {
            result = mapping;
        } else {
            result = mapping?.FieldName || '';
        }
        
        console.log(`🔍 getFieldMapping(${columnIndex}):`, result, 'from', mapping);
        return result;
    }
    
    generateDefaultMapping = () => {
        const element = this.getElement();
        if (!element.TableData || !element.TableData[0]) return [];
        return element.TableData[0].Cells.map(() => '');
    }

    handleStructuredBindingChange = (binding) => {
        const {activeElement, objects} = this.props;
        const elementId = activeElement.id || activeElement;
        const currentElement = objects[elementId] || {};
        const currentProps = currentElement.properties || {};

        this.props.changePropertiesById2(elementId, {
            binding,
            properties: {
                ...currentProps,
                binding
            }
        });
    }
    
    getElement = () => {
        const {activeElement, objects} = this.props;
        let element = null;
        let rootElement = null;
        
        // Check if activeElement is an object (with properties) or just an ID string
        if (activeElement) {
            // If activeElement is already the full object with properties
            if (activeElement.properties) {
                element = activeElement.properties;
                rootElement = activeElement;
            }
            // If activeElement is an ID string, look it up in objects
            else if (typeof activeElement === 'string' && objects[activeElement]) {
                element = objects[activeElement].properties;
                rootElement = objects[activeElement];
            }
        }
        
        // Fallback to objeler only on initial load before Redux is ready
        if (!element && objeler.ElementProps && objeler.ElementProps.Object && objeler.ElementProps.Object.properties) {
            element = objeler.ElementProps.Object.properties;
            rootElement = objeler.ElementProps.Object;
        }
        
        // Merge root level properties (DataSource, ColumnMapping) for Table elements
        if (element && rootElement && rootElement.type === 'Table') {
            // Priority: root level > properties level
            // Use root if it exists, otherwise fallback to properties
            const merged = {
                ...element,
                DataSource: rootElement.hasOwnProperty('DataSource') ? rootElement.DataSource : (element.DataSource || ''),
                ColumnMapping: rootElement.hasOwnProperty('ColumnMapping') ? rootElement.ColumnMapping : (element.ColumnMapping || [])
            };
            console.log('🔍 getElement merge:', {
                rootDataSource: rootElement.DataSource,
                propsDataSource: element.DataSource,
                finalDataSource: merged.DataSource,
                rootColumnMapping: rootElement.ColumnMapping,
                propsColumnMapping: element.ColumnMapping,
                finalColumnMapping: merged.ColumnMapping,
                hasRootColumnMapping: rootElement.hasOwnProperty('ColumnMapping')
            });
            return merged;
        }
        
        return element || {};
    }
    
    renderDataSourceSelector() {
        const element = this.getElement();
        const dataSourceItems = this.getDataSourceItems();
        
        // Find current selection for EditableSelect
        const currentValue = element.DataSource || '';
        const selectedOption = dataSourceItems.find(ds => ds.value === currentValue);
        
        return (
            <div className="property-group" style={{marginBottom: '15px'}}>
                <h4>Data Source</h4>
                {dataSourceItems.length === 0 ? (
                    <div style={{padding: '10px', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px', marginBottom: '10px'}}>
                        <strong>⚠️ No Data Source Available</strong>
                        <p style={{margin: '5px 0 0 0', fontSize: '13px'}}>
                            Please load an Excel file from Data Properties first.
                        </p>
                    </div>
                ) : (
                    <EditableSelect
                        value={currentValue}
                        comboValue={selectedOption}
                        items={dataSourceItems}
                        onChange={this.handleDataSourceChange}
                    />
                )}
                <div style={{marginTop: '10px'}}>
                    <input
                        type="checkbox"
                        id="continuous"
                        checked={element.Continuous || false}
                        onChange={this.handleContinuousChange}
                    />
                    <label htmlFor="continuous" style={{marginLeft: '5px'}}>
                        Repeat header on every page
                    </label>
                </div>
            </div>
        );
    }
    
    renderFieldMapping() {
        const element = this.getElement();
        const dataSource = this.getSelectedDataSource();
        
        if (!dataSource || !dataSource.Fields || dataSource.Fields.length === 0) {
            return (
                <div className="property-group" style={{marginBottom: '15px', padding: '10px', backgroundColor: '#fff3cd', border: '1px solid #ffc107', borderRadius: '4px'}}>
                    <strong>⚠️ No Fields Available</strong>
                    <p style={{margin: '5px 0 0 0', fontSize: '13px'}}>
                        {!dataSource ? 'Please select a DataSource first.' : 'Selected DataSource has no fields.'}
                    </p>
                </div>
            );
        }
        
        // Get columns from Columns property or TableData
        let columns = [];
        if (element.Columns && element.Columns.length > 0) {
            columns = element.Columns;
        } else if (element.TableData && element.TableData[0]) {
            columns = element.TableData[0].Cells.map((cell, idx) => ({
                Name: cell.v || `Column ${idx + 1}`
            }));
        } else {
            // Default 4 columns for dynamic table
            columns = Array(4).fill(null).map((_, idx) => ({Name: `Column ${idx + 1}`}));
        }
        
        return (
            <div className="property-group" style={{marginBottom: '15px'}}>
                <h4>Column → Field Mapping</h4>
                <p style={{fontSize: '12px', color: '#666', marginBottom: '10px'}}>
                    Map each table column to a field from <strong>{dataSource.Name}</strong>
                </p>
                {columns.map((col, index) => (
                    <div key={index} style={{marginBottom: '10px'}}>
                        <label style={{display: 'block', marginBottom: '5px', fontWeight: '500'}}>
                            Column {index + 1}: {col.Name || '(empty)'}
                        </label>
                        <select
                            value={this.getFieldMapping(index)}
                            onChange={(e) => this.handleFieldMappingChange(index, e.target.value)}
                            style={{
                                width: '100%', 
                                padding: '6px',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                fontSize: '13px'
                            }}
                        >
                            <option value="">-- Select Field --</option>
                            {dataSource.Fields.map(field => (
                                <option key={field.Name} value={field.Name}>
                                    {field.Name}
                                </option>
                            ))}
                        </select>
                    </div>
                ))}
            </div>
        );
    }
    
    renderTableStructureEditor() {
        const element = this.getElement();
        const tableData = element.TableData || [];
        
        // Initialize table if empty
        if (tableData.length === 0) {
            return (
                <div className="property-group" style={{marginBottom: '15px'}}>
                    <h4>Table Structure</h4>
                    <p style={{marginBottom: '10px', color: '#666'}}>No table data. Click to initialize:</p>
                    <button 
                        onClick={this.initializeTableData}
                        style={{
                            width: '100%',
                            padding: '10px',
                            backgroundColor: '#4CAF50',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer'
                        }}
                    >
                        Create Table (3 columns × 3 rows)
                    </button>
                </div>
            );
        }
        
        const rowCount = tableData.length;
        const columnCount = tableData[0] ? tableData[0].Cells.length : 0;
        
        return (
            <div className="property-group" style={{marginBottom: '15px'}}>
                <h4>Table Structure</h4>
                
                <div style={{marginBottom: '10px'}}>
                    <strong>Size:</strong> {columnCount} columns × {rowCount} rows
                </div>
                
                {/* Row Controls */}
                <div style={{marginBottom: '10px'}}>
                    <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Rows</label>
                    <div style={{display: 'flex', gap: '5px'}}>
                        <button 
                            onClick={this.handleAddRow}
                            style={{
                                flex: 1,
                                padding: '8px',
                                backgroundColor: '#2196F3',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            + Add Row
                        </button>
                        <button 
                            onClick={this.handleRemoveRow}
                            disabled={rowCount <= 1}
                            style={{
                                flex: 1,
                                padding: '8px',
                                backgroundColor: rowCount <= 1 ? '#ccc' : '#f44336',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: rowCount <= 1 ? 'not-allowed' : 'pointer'
                            }}
                        >
                            - Remove Row
                        </button>
                    </div>
                </div>
                
                {/* Column Controls */}
                <div style={{marginBottom: '15px'}}>
                    <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>Columns</label>
                    <div style={{display: 'flex', gap: '5px'}}>
                        <button 
                            onClick={this.handleAddColumn}
                            style={{
                                flex: 1,
                                padding: '8px',
                                backgroundColor: '#2196F3',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            + Add Column
                        </button>
                        <button 
                            onClick={this.handleRemoveColumn}
                            disabled={columnCount <= 1}
                            style={{
                                flex: 1,
                                padding: '8px',
                                backgroundColor: columnCount <= 1 ? '#ccc' : '#f44336',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: columnCount <= 1 ? 'not-allowed' : 'pointer'
                            }}
                        >
                            - Remove Column
                        </button>
                    </div>
                </div>
                
                {/* Cell Editor */}
                <div>
                    <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>
                        Edit Cells
                    </label>
                    <div style={{
                        maxHeight: '300px',
                        overflowY: 'auto',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        padding: '10px'
                    }}>
                        {tableData.map((row, rowIndex) => (
                            <div key={rowIndex} style={{marginBottom: '10px'}}>
                                <div style={{
                                    fontWeight: 'bold',
                                    marginBottom: '5px',
                                    color: '#333'
                                }}>
                                    Row {rowIndex + 1}
                                </div>
                                {row.Cells.map((cell, cellIndex) => (
                                    <div key={cellIndex} style={{marginBottom: '5px'}}>
                                        <input
                                            type="text"
                                            value={cell.v || ''}
                                            onChange={(e) => this.handleCellEdit(rowIndex, cellIndex, e.target.value)}
                                            placeholder={`Cell [${rowIndex + 1}, ${cellIndex + 1}]`}
                                            style={{
                                                width: '100%',
                                                padding: '6px',
                                                border: '1px solid #ddd',
                                                borderRadius: '3px',
                                                fontSize: '13px'
                                            }}
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        );
    }
    
    renderFlowSettings() {
        const {activeElement, objects} = this.props;
        const element = this.getElement();
        const allElements = Object.keys(objects || {}).map(key => {
            const obj = objects[key];
            const props = obj.properties || {};
            // Build a readable label: type + text/datasource/name
            let label = obj.type || 'Unknown';
            if (props.Text && props.Text.length > 0) {
                const shortText = props.Text.length > 25 ? props.Text.substring(0, 25) + '...' : props.Text;
                label += ` - "${shortText}"`;
            } else if (props.DataSource && props.DataSource.length > 0) {
                label += ` [${props.DataSource}]`;
            } else if (props.BarcodeType) {
                label += ` (${props.BarcodeType})`;
            }
            return { id: key, type: obj.type, label: label };
        });
        
        return (
            <div className="property-group" style={{marginBottom: '15px'}}>
                <h4>Flow Layout</h4>
                <div>
                    <input
                        type="checkbox"
                        id="flowLayout"
                        checked={element.FlowLayout || false}
                        onChange={this.handleFlowLayoutChange}
                    />
                    <label htmlFor="flowLayout" style={{marginLeft: '5px'}}>
                        Enable Flow Layout
                    </label>
                </div>
                
                {element.FlowLayout && (
                    <div style={{marginTop: '10px'}}>
                        <label style={{display: 'block', marginBottom: '5px'}}>Flow After</label>
                        <select
                            value={element.FlowAfter || ''}
                            onChange={this.handleFlowAfterChange}
                            style={{width: '100%', padding: '5px', marginBottom: '10px'}}
                        >
                            <option value="">-- Select Element --</option>
                            {allElements.filter(e => e.id !== activeElement).map(e => (
                                <option key={e.id} value={e.id}>
                                    {e.label}
                                </option>
                            ))}
                        </select>
                        
                        <label style={{display: 'block', marginBottom: '5px'}}>Margin (px)</label>
                        <input
                            type="number"
                            min="0"
                            max="100"
                            value={element.FlowMargin || 20}
                            onChange={this.handleFlowMarginChange}
                            style={{width: '100%', padding: '5px'}}
                        />
                    </div>
                )}
            </div>
        );
    }
    
    render() {
        const {activeElement, objects} = this.props;
        
        // Check if we have a valid element
        if (!activeElement && (!objeler.ElementProps || !objeler.ElementProps.Object)) {
            return <div>No element selected</div>;
        }
        
        const element = this.getElement();
        if (!element || Object.keys(element).length === 0) {
            return <div>No element selected</div>;
        }
        
        // Debug logging
        console.log('TableProperties render - BorderWidth:', element.BorderWidth, 'BorderColor:', element.BorderColor);
        
        const isDynamic = element.Mode === 'Dynamic';
        
        return (
            <div className="table-properties" style={{padding: '10px', maxHeight: '600px', overflowY: 'auto'}}>
                <h3>Table Properties</h3>
                
                {/* Mode Selector */}
                <div className="property-group" style={{marginBottom: '15px'}}>
                    <label style={{display: 'block', marginBottom: '5px', fontWeight: 'bold'}}>
                        Table Mode
                    </label>
                    <select 
                        value={element.Mode || 'Manual'}
                        onChange={this.handleModeChange}
                        style={{width: '100%', padding: '5px'}}
                    >
                        <option value="Manual">Manual (Static)</option>
                        <option value="Dynamic">Dynamic (DataSource)</option>
                    </select>
                    <div style={{fontSize: '12px', color: '#666', marginTop: '6px'}}>
                        Structured Binding works independently from legacy Dynamic DataSource mode. For Beko JSON templates, Manual mode can be used.
                    </div>
                </div>

                <StructuredBindingPanel
                    kind="table"
                    binding={element.binding}
                    onBindingChange={this.handleStructuredBindingChange}
                />
                
                {/* Table Structure Editor (Manual mode only) */}
                {!isDynamic && this.renderTableStructureEditor()}
                
                {/* DataSource Settings (Dynamic mode only) */}
                {isDynamic && (
                    <>
                        {/* Validation Error Message */}
                        {this.state.validationError && (
                            <div style={{
                                padding: '10px',
                                marginBottom: '15px',
                                backgroundColor: '#fff3cd',
                                border: '2px solid #ff9800',
                                borderRadius: '4px',
                                color: '#856404',
                                fontWeight: 'bold'
                            }}>
                                {this.state.validationError}
                            </div>
                        )}
                        
                        {this.renderDataSourceSelector()}
                        {this.renderFieldMapping()}
                    </>
                )}
                
                {/* Border Settings */}
                <div className="property-group" style={{marginBottom: '15px'}}>
                    <h4>Border</h4>
                    
                    <label style={{display: 'block', marginBottom: '5px'}}>
                        Color
                    </label>
                    <input
                        type="color"
                        value={element.BorderColor || '#000000'}
                        onChange={this.handleBorderColorChange}
                        style={{width: '100%', height: '30px'}}
                    />
                    
                    <label style={{display: 'block', marginTop: '10px', marginBottom: '5px'}}>
                        Width (px)
                    </label>
                    <input
                        type="number"
                        min="0"
                        max="10"
                        value={element.BorderWidth || 1}
                        onChange={this.handleBorderWidthChange}
                        style={{width: '100%', padding: '5px'}}
                    />
                    
                    <label style={{display: 'block', marginTop: '10px', marginBottom: '5px'}}>
                        Style
                    </label>
                    <select
                        value={element.BorderStyle || 'Solid'}
                        onChange={this.handleBorderStyleChange}
                        style={{width: '100%', padding: '5px'}}
                    >
                        <option value="Solid">Solid</option>
                        <option value="Dashed">Dashed</option>
                        <option value="Dotted">Dotted</option>
                        <option value="Double">Double</option>
                    </select>
                </div>
                
                {/* Row Settings */}
                <div className="property-group" style={{marginBottom: '15px'}}>
                    <h4>Rows</h4>
                    
                    <label style={{display: 'block', marginBottom: '5px'}}>
                        Header Height (px)
                    </label>
                    <input
                        type="number"
                        min="20"
                        max="100"
                        value={element.HeaderHeight || 30}
                        onChange={this.handleHeaderHeightChange}
                        style={{width: '100%', padding: '5px'}}
                    />
                    
                    <label style={{display: 'block', marginTop: '10px', marginBottom: '5px'}}>
                        Row Height (px)
                    </label>
                    <input
                        type="number"
                        min="15"
                        max="100"
                        value={element.RowHeight || 25}
                        onChange={this.handleRowHeightChange}
                        style={{width: '100%', padding: '5px'}}
                    />
                    
                    <div style={{marginTop: '10px'}}>
                        <input
                            type="checkbox"
                            id="zebraStripe"
                            checked={element.ZebraStripe || false}
                            onChange={this.handleZebraStripeChange}
                        />
                        <label htmlFor="zebraStripe" style={{marginLeft: '5px'}}>
                            Zebra Stripe
                        </label>
                    </div>
                    
                    {element.ZebraStripe && (
                        <div style={{marginTop: '10px'}}>
                            <label style={{display: 'block', marginBottom: '5px'}}>
                                Alternate Color
                            </label>
                            <input
                                type="color"
                                value={element.AlternateColor || '#f5f5f5'}
                                onChange={this.handleAlternateColorChange}
                                style={{width: '100%', height: '30px'}}
                            />
                        </div>
                    )}
                </div>
                
                {/* Flow Layout Settings */}
                {this.renderFlowSettings()}
                
                {/* Page Break Settings */}
                <div className="property-group" style={{marginBottom: '15px'}}>
                    <h4>Page Break</h4>
                    
                    <div>
                        <input
                            type="checkbox"
                            id="keepTogether"
                            checked={element.KeepTogether || false}
                            onChange={this.handleKeepTogetherChange}
                        />
                        <label htmlFor="keepTogether" style={{marginLeft: '5px'}}>
                            Keep Together (Never split)
                        </label>
                    </div>
                    
                    <label style={{display: 'block', marginTop: '10px', marginBottom: '5px'}}>
                        Minimum Rows on Page
                    </label>
                    <input
                        type="number"
                        min="1"
                        max="20"
                        value={element.MinRowsOnPage || 3}
                        onChange={this.handleMinRowsChange}
                        style={{width: '100%', padding: '5px'}}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    activeElement: state.appReducers.activeElement,
    objects: state.appReducers.objects
});

export default connect(mapStateToProps, {changeProperties, changePropertiesById2})(TableProperties);
